import { render, staticRenderFns } from "./contractChangeManageList.vue?vue&type=template&id=32638f54&scoped=true"
import script from "./contractChangeManageList.vue?vue&type=script&lang=js"
export * from "./contractChangeManageList.vue?vue&type=script&lang=js"
import style0 from "./contractChangeManageList.vue?vue&type=style&index=0&id=32638f54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32638f54",
  null
  
)

export default component.exports